import { ApiError, apiFetch, parseErrorDetail } from "@/api/fetch";
import type { UsageResponse } from "@/features/auth/api/usage";
import { useAuth } from "@/features/auth/hooks/useAuth";
import { USAGE_QUERY_KEY } from "@/features/usage/constants";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

export const useUsage = () => {
  const { token } = useAuth();
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: USAGE_QUERY_KEY,
    queryFn: async (): Promise<UsageResponse> => {
      const res = await apiFetch("/users/me/usage");
      if (!res.ok) throw new ApiError(await parseErrorDetail(res), res.status);
      return (await res.json()) as UsageResponse;
    },
    enabled: !!token,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });

  const refetchUsage = useCallback(() => {
    void queryClient.invalidateQueries({ queryKey: USAGE_QUERY_KEY });
  }, [queryClient]);

  return {
    ...query,
    refetchUsage,
  };
};
